import type { SimEvents } from '../sim/events';

export type ImpactListener = { entity: number; slot: number; x: number; y: number; alive: boolean };
export type RumbleKind = 'hit' | 'boom' | 'block';

/** Local impact feedback. Remote duels remain audible/visible without interrupting your controls. */
export function combatImpact(events: SimEvents, listeners: ImpactListener[], spectator = false) {
  let stop = 0,
    shake = 0;
  const rumbles = new Map<number, RumbleKind>();
  const involved = (source: number, target: number) =>
    listeners.some((p) => p.entity === source || p.entity === target);
  const near = (x: number, y: number, radius: number) =>
    listeners.filter((p) => p.alive && Math.hypot(p.x - x, p.y - y) <= radius);
  for (const event of events) {
    if (event.type === 'kill' && (spectator || involved(event.source, event.target))) {
      stop = Math.max(stop, 3);
      shake = Math.max(shake, 7);
    } else if (event.type === 'hit') {
      if (event.damage >= 15 && (spectator || involved(event.source, event.target))) {
        stop = Math.max(stop, 1);
        shake = Math.max(shake, 3);
      }
      for (const p of listeners)
        if (p.entity === event.target && !rumbles.has(p.slot)) rumbles.set(p.slot, 'hit');
    } else if (event.type === 'explosion') {
      const nearby = near(event.x, event.y, event.radius + 3);
      if (spectator || nearby.length) shake = Math.max(shake, 10);
      for (const p of nearby) rumbles.set(p.slot, 'boom');
    } else if (event.type === 'clash' && (spectator || near(event.x, event.y, 2).length)) {
      stop = Math.max(stop, 1);
      shake = Math.max(shake, 2);
    } else if (event.type === 'block' && event.reflected) {
      for (const p of listeners)
        if (p.entity === event.player && !rumbles.has(p.slot)) rumbles.set(p.slot, 'block');
    }
  }
  return { stop, shake, rumbles };
}
